import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './ContractConnectivityDetail.html';
import SenderConectivityDetailService from './ContractConnectivityDetailService';
import { Toaster } from '../../Services/toast';
import { FilterModel } from './filterModel';
import { SenderConectivityStatus } from '../../shared/Enums/SenderConectivityStatus';
import { AddConectivityModel } from './addContractConnectivityModel';
import { ShortModel } from '../Short/ShortModel';
import ShortService from '../Short/ShortService';
import { SenderInfoModel } from './senderInfoModel';
import { SenderType } from '../../shared/Enums/SenderType';
import UserService from '../../shared/userService/UserService';
import { ContractConnectivityDetaillogModel } from './ContractConnectivityDetaillogModel';
import UserRoleService from '../../shared/userService/UserRoleService';
import { ShortCodeType } from '../../shared/Enums/ShortCodeType';
import ContractConnectivityDetailService from './ContractConnectivityDetailService';
import { ContractConnectivityDetailModel } from './ContractConnectivityDetailModel';
import ProviderStatusService from '../../shared/ProviderStatusService/ProviderStatusService';
import RatingService from '@/components/Rating/RatingService';
import { RatingServiceType } from '@/components/Rating/RatingServiceType';
import { ServiceRatingModel } from '@/components/Rating/ServiceRatingModel';
import OperatorService from '@/Services/OperatorService';
import ProviderService from '@/components/Provider/ProviderService';
import VirtualOperatorRules from '@/shared/VirtualOperatorRules';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ContractConnectivityDetailService,
        ShortService,
        UserService,
        UserRoleService,
        ProviderStatusService,
        RatingService,
        OperatorService,
        ProviderService,
    ],
})
export default class SenderConectivityDetail extends Vue {
    @Inject(ContractConnectivityDetailService) public senderConectivityService!: SenderConectivityDetailService;
    @Inject(ShortService) public shortService!: ShortService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(ProviderStatusService) public providerStatusService!: ProviderStatusService;
    @Inject(RatingService) public ratingService!: RatingService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Prop({ type: Number, required: true }) public serviceType!: number;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ type: String, default: '' })
    public senderId: string | any;

    public isModeShow: boolean = false;
    public deleteDialog: boolean = false;
    public resendToOperatorDialog: boolean = false;
    public addDialog: boolean = false;
    public logDialog: boolean = false;
    public providerDissconected: boolean = true;
    public conectivityId: string = '';
    public senderType: SenderType[] = [];
    public isAlreadyExistEnabled: boolean = false;
    public User: any;
    public userRole: any;
    public headers: any = [
        { text: this.$t('shortPage.company'), value: 'operator', align: 'center', sortable: false },
        { text: this.$t('shortPage.shortCode'), value: 'shortCodeName', align: 'center', sortable: false },
        { text: this.$t('shared.senderType'), value: 'senderType', align: 'center', sortable: false },
        { text: this.$t('shared.conectivityStatus'), value: 'status', align: 'center', sortable: false },
        { text: this.$t('shared.resendtooperator'), sortable: false, value: 'id', align: 'center' },
        { text: this.$t('shared.actions'), sortable: false, value: 'id', align: 'center', width: '100' },
    ];

    public operatorOptions: any[] = [];
    public virtualOperatorLocked: boolean = false;
    public senderTypeOptions: any[] = [];
    public shortCodeOptions: ShortModel[] = [];
    public shortCode: ShortModel[] = [];
    public connectivities: ContractConnectivityDetailModel[] = [];
    public allConnectivities: ContractConnectivityDetailModel[] = [];
    public connectivitiesCount: number = 0;
    public pagination: any = {
        page: 1,
        rowsPerPage: 10,
    };
    private isResetting: boolean = false;
    public filterModel: FilterModel = {
        operator: '',
        shortCodeName: '',
        status: 0,
    };
    public showRatingDialog: boolean = false;
    public rating: number = 0;
    public reason: string = '';
    public submitting: boolean = false;

    public senderInfo: SenderInfoModel = {
        id: '',
        senderName: '',
        senderStatus: 0,
        senderType: 0,
        duration: 0,
        startDate: '',
        clientName: '',
        crNumber: '',
        customerType: 0,
        isAlreadyExist: false,
    };

    public addModel: AddConectivityModel = {
        operator: 0,
        senderId: '',
        shortCodeId: [],
        senderType: 0,
        isAlreadyExist: false,
    };
    public logModel: ContractConnectivityDetaillogModel = {
        id: '',
        addRequest: '',
        addResponse: '',
        deleteRequest: '',
        deleteResponse: '',
    };
    public statusOptions: any[] = [
        {
            id: SenderConectivityStatus.PendingAddition,
            name: this.$t('shared.pendingAddition').toString(),
        },
        {
            id: SenderConectivityStatus.Added,
            name: this.$t('shared.added').toString(),
        },
        {
            id: SenderConectivityStatus.PendingDeletion,
            name: this.$t('shared.pendingDeletion').toString(),
        },
        {
            id: SenderConectivityStatus.Deleted,
            name: this.$t('shared.deleted').toString(),
        },
    ];
    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }
    public async created() {
        this.$emit('childinit', this.layoutSup);
        const response = await this.operatorService.getAll();
        if (response.isSuccess) {
            this.operatorOptions = response.result;
        }
    }

    public async mounted() {
        this.User = await this.userService.getUser();
        this.userRole = this.GetUserRole();
        if (this.User && this.User.details && this.User.details.ProviderId) {
            const provider = await this.providerService.GetById(this.User.details.ProviderId);
            this.applyVirtualOperatorOperatorLock(provider);
        }
        const option = await this.senderConectivityService.getConnectivityConfiguration();
        this.isAlreadyExistEnabled = option.result.isAlreadyExistEnabled;
        await this.isProviderDissconected();
        await this.loadConnectivities();
        const responseSenderInfo = await this.senderConectivityService.getSenderInfo(this.senderId);
        this.senderInfo = responseSenderInfo.result;
        const responseShortCode = await this.shortService.getAll(true);
        this.shortCode = responseShortCode.result;
        this.getSenderType();
        let sumSenderType = 0;
        let sumSenderTypeText = '';
        this.senderType.filter((x) => x !== 1).forEach((x, index) => {
            sumSenderType += x;
            sumSenderTypeText += this.getSenderTypeText(x);
            if (this.senderType.filter((y) => y !== 1).length !== index + 1) {
                sumSenderTypeText += ' , ';
            }
        });
        if (this.senderType.filter((x) => x === 1).length !== 0) {
            this.senderTypeOptions.push({
                id: 1,
                name: this.getSenderTypeText(1),
            });
        }
        if (sumSenderType !== 0) {
            this.senderTypeOptions.push({
                id: sumSenderType,
                name: sumSenderTypeText,
            });
        }
    }

    private applyVirtualOperatorOperatorLock(provider: any) {
        if (!provider) {
            return;
        }
        const result = VirtualOperatorRules.filterOperatorOptionsById(provider, this.operatorOptions);
        this.operatorOptions = result.options;
        this.virtualOperatorLocked = result.locked;
        if (result.operatorId !== null) {
            this.addModel.operator = result.operatorId;
        }
    }

    @Watch('addModel.operator', { deep: true })
    public onchangeOperator() {
        this.filterShortCodeByOperator();
        this.filterShortCodeByType();
    }

    @Watch('addModel.senderType', { deep: true })
    public onchangeSenderType() {
        this.filterShortCodeByOperator();
        this.filterShortCodeByType();
    }
    public async isProviderDissconected() {
        const response = await this.providerStatusService.isProviderDissconected();
        this.providerDissconected = response.result;
    }
    @Watch('filterModel', { deep: true })
    public async search() {
        if (this.isResetting) {
            return;
        }
        this.pagination.page = 1;
        await this.loadConnectivities();
    }

    public async updatePaginate(val: any) {
        this.pagination.page = val.page;
        this.pagination.rowsPerPage = val.rowsPerPage;
        await this.loadConnectivities();
    }

    public async reset() {
        this.isResetting = true;
        this.filterModel = {
            operator: '',
            shortCodeName: '',
            status: 0,
        };
        this.pagination = {
            page: 1,
            rowsPerPage: 10,
        };
        await this.$nextTick();
        this.isResetting = false;
        await this.loadConnectivities();
    }

    private async loadConnectivities() {
        const response = await this.senderConectivityService.get(
            this.senderId,
            this.filterModel.operator || '',
            this.filterModel.shortCodeName || '',
            this.filterModel.status || 0,
            this.pagination.page - 1,
            this.pagination.rowsPerPage,
        );
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            return;
        }
        this.connectivities = response.result;
        this.connectivitiesCount = response.totalCount;
    }

    private filterShortCodeByType() {
        if (this.addModel.senderType === 0 || this.addModel.senderType === null) {
            return;
        }
        else if (this.addModel.senderType === SenderType.Advertisement) {
            this.shortCodeOptions = this.shortCodeOptions.filter((x) => x.shortCodeType === ShortCodeType.BlackList);
        }
        else {
            this.shortCodeOptions = this.shortCodeOptions.filter((x) => x.shortCodeType === ShortCodeType.WhiteList);
        }
    }

    private filterShortCodeByOperator() {
        this.shortCodeOptions = this.shortCode.filter((x) => x.operatorId === this.addModel.operator);
        this.addModel.shortCodeId = [];
    }
  
  public getOperatorText(operatorId: number): string {
     const operator = this.operatorOptions.find(op => op.id === operatorId);
       return operator ? operator.name : '-';
   }
    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }

    public getConectivityStatusText(status: number) {
        switch (status) {
            case SenderConectivityStatus.PendingAddition:
                return this.$t('shared.pendingAddition').toString();
            case SenderConectivityStatus.Added:
                return this.$t('shared.added').toString();
            case SenderConectivityStatus.PendingDeletion:
                return this.$t('shared.pendingDeletion').toString();
            case SenderConectivityStatus.Deleted:
                return this.$t('shared.deleted').toString();
            case SenderConectivityStatus.Canceled:
                return this.$t('shared.canceled').toString()
            case SenderConectivityStatus.Skipped:
                return this.$t('shared.skipped').toString();
            default:
                return '-';
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }

    public getSenderType() {
        const senderBinary = this.senderInfo.senderType;

        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }

    public getSenderTypeTextTable(senderType: number) {
        let senderTypeText = '';
        const senderTypeList = [];
        if ((senderType & 1) === 1) {
            senderTypeList.push(this.getSenderTypeText(1));
        }
        if ((senderType & 2) === 2) {
            senderTypeList.push(this.getSenderTypeText(2));
        }
        if ((senderType & 4) === 4) {
            senderTypeList.push(this.getSenderTypeText(4));
        }
        if ((senderType & 8) === 8) {
            senderTypeList.push(this.getSenderTypeText(8));
        }
        senderTypeText = senderTypeList.join(' / ');
        return senderTypeText;
    }


    public isEqual(value1: string | null, value2: string) {
        return (value1 === '' || value1 === null || value1 === undefined || value2.includes(value1));
    }

    public showDeleteDialog(id: string) {
        this.conectivityId = id;
        this.deleteDialog = true;
    }

    public async showAddConectivityDialog() {
        this.addModel = {
            senderId: '',
            shortCodeId: [],
            operator: 0,
            senderType: 0,
            isAlreadyExist: this.senderInfo.isAlreadyExist,
        };
        if (this.virtualOperatorLocked && this.operatorOptions.length === 1) {
            this.addModel.operator = this.operatorOptions[0].id;
        }
        await this.loadAllConnectivitiesForDuplicateCheck();
        this.addDialog = true;
    }

    private async loadAllConnectivitiesForDuplicateCheck() {
        const response = await this.senderConectivityService.get(
            this.senderId,
            '',
            '',
            0,
            0,
            10000,
        );
        if (response && response.isSuccess) {
            this.allConnectivities = response.result;
        }
    }

    public async showlogDialog(id: string) {
        const response = await this.senderConectivityService.getLogDetails(id);
        this.logModel = response.result;
        this.logDialog = true;
    }
    public hidelogDialog() {
        this.logModel = {
            id: '',
            addRequest: '',
            addResponse: '',
            deleteRequest: '',
            deleteResponse: '',
        };
        this.logDialog = false;
    }

    public hideDeleteDialog() {
        this.deleteDialog = false;
    }

    public hideAddDialog() {
        this.addDialog = false;
    }

    public showResendToOperatorDialog(id: string) {
        this.conectivityId = id;
        this.resendToOperatorDialog = true;
    }
    public hideResendToOperatorDialog() {
        this.resendToOperatorDialog = false;
    }

    public selectAllToggle() {
        this.$nextTick(() => {
            if (this.selectAllShortCode) {
                this.addModel.shortCodeId = [];
            } else {
                this.addModel.shortCodeId = this.shortCodeOptions.slice().map((x) => x.id);
            }
        });
    }

    public get selectAllShortCode() {
        return this.addModel.shortCodeId.length === this.shortCodeOptions.length;
    }

    public get selectSomeShortCode() {
        return this.addModel.shortCodeId.length > 0 && !this.selectAllShortCode;
    }

    public get icon() {
        if (this.selectAllShortCode) {
            return 'check_box';
        }

        if (this.selectSomeShortCode) {
            return 'indeterminate_check_box';
        }
        return 'check_box_outline_blank';
    }

    public save() {
        this.isModeShow = true;
    }

    public async addConectivity() {
        this.addModel.senderId = this.senderId;
        const response = await this.senderConectivityService.post(this.addModel);
        const canRate = await this.ratingService.canRate(RatingServiceType.ConnectivityRequest);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.addConectivitySuccessfully').toString());
            this.addDialog = false;
            this.isModeShow = false;
            if (canRate) {
                this.showRatingDialog = true;
            } else {
                this.reload();
            }
        } else {
            Toaster.error(response.errorMessage);
        }
    }

    public async resendToOperator() {
        const response = await this.senderConectivityService.markAsPendingAddition(this.conectivityId);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.resentSuccessfully').toString());
            this.reload();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.resendToOperatorDialog = false;
    }

    public get isValid(): boolean {
        return (this.addModel.senderType !== 0 && this.addModel.senderType !== null
            && this.addModel.senderType !== undefined &&
            this.addModel.operator !== 0 && this.addModel.operator !== null
            && this.addModel.operator !== undefined && this.addModel.shortCodeId.length !== 0);
    }

    public async deleteConectivity() {
        const response = await this.senderConectivityService.delete(this.conectivityId);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.deleteConectivitySuccessfully').toString());
            this.reload();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.deleteDialog = false;
    }


    public async reload() {
        this.pagination.page = 1;
        await this.loadConnectivities();
    }

    public back() {
        this.isModeShow = false;
    }

    get reasonRequired(): boolean {
        return this.rating > 0 && this.rating <= 2;
    }

    get canSubmit(): boolean {
        return this.rating > 0 && (!this.reasonRequired || this.reason.trim().length > 0);
    }

    public async submitRating() {
        if (!this.canSubmit) return;
        this.submitting = true;
        const model: ServiceRatingModel = {
            rating: this.rating,
            reason: this.reason,
            serviceType: RatingServiceType.ConnectivityRequest,
        };
        const response = await this.ratingService.addRating(model);
        if (response.isSuccess) {
            Toaster.success(this.$t('shared.ratingSuccess').toString());
            this.resetForm();
            this.showRatingDialog = false;
            this.reload();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.submitting = false;
    }

    public resetForm() {
        this.rating = 0;
        this.reason = '';
    }

    public isOptionAdded(item: ShortModel): boolean {
        const inFlight = [
            SenderConectivityStatus.PendingAddition,
            SenderConectivityStatus.Added,
            SenderConectivityStatus.PendingDeletion,
        ];
        return this.allConnectivities.some(
            c =>
                c.shortCodeId === item.id &&
                inFlight.includes(c.status)
        );
    }
}
